// MpfPagination.props.ts
// NHS Design System: https://service-manual.nhs.uk/design-system/components/pagination

export interface MpfPaginationProps {
  previousLabel?: string;
  nextLabel?: string;
  hasPrevious?: boolean;
  hasNext?: boolean;
  previousAriaLabel?: string;
  nextAriaLabel?: string;
}

// Defaults MUST be values (NOT factories) when using withDefaults
export const mpfPaginationDefaults = {
  previousLabel: 'Previous 2 weeks',
  nextLabel: 'Next 2 weeks',
  hasPrevious: true,
  hasNext: true,
} satisfies Partial<MpfPaginationProps>;

// Buttons, not links: the store holds the date window, so there is no href to
// navigate to and no history entry worth creating per page turn.
export type MpfPaginationEmits = {
  (e: 'previous'): void;
  (e: 'next'): void;
};
